<template>
  <div class="nsaleBs_">
    <div class="form_ content_">
      <div class="input_">
        <div class="text_">手机号码：</div>
        <cube-input class="logStyle" placeholder="请输入姓名"></cube-input>
      </div>

      <div class="input_">
        <div class="text_">验证码：</div>
        <cube-input class="logStyle" placeholder="请输入验证码"></cube-input>
        <span class="verCode_">发送验证码</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import moment from "moment";

export default {
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.nsaleBs_ {
  padding: 15px;
  min-height: 100vh;
  font-size: 15px;
  .content_ {
    padding: 0 25px;
    border-radius: 5px;
    .input_ {
      width: 305px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f7f7f7;
      padding: 5px 0;
      position: relative;
      .text_ {
        color: rgba(51, 51, 51, 1);
        width: 100px;
        text-align: left;
        height: 40px;
        line-height: 40px;
      }
      .text_1 {
        font-size: 15px;
        color: rgba(20, 35, 75, 1);
        margin: 0 10px;
        height: 40px;
        line-height: 40px;
      }
      .img_ {
        height: 13px;
        width: auto;
      }
      .logStyle {
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(204, 204, 204, 1);
        height: 36px;
        border-radius: 18px;
        background: none;
        display: flex;
      }
      .input_c {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .verCode_ {
        position: absolute;
        top: 33%;
        right: 0;
        font-size: 15px;
        color: rgba(255, 74, 53, 1);
      }
    }
  }
}

.cube-input::after {
  border: none;
}
</style>
